<template>
  <div class="flex">
    <div v-for="(filter, idx) in filters" :key="idx" style="margin-right: 10px">
      <FilterDateRange
        :filter="filter.designator"
        :label="filter.label"
        :onSubmit="updateFilter" />
    </div>
  </div>
</template>
<script>
  import FilterDateRange from '@/components/FilterDateRange'
  export default {
    name: 'FilterDateRanges',
    components: {
      FilterDateRange
    },
    props: {
      filters: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      updateFilter(filter, startDate, endDate) {


        let query = { ...this.$route.query }

        query[`${filter}_start`] =
          startDate == undefined ? undefined : startDate
        query[`${filter}_end`] = endDate == undefined ? undefined : endDate

        this.$router.push({ path: this.$route.path, query: query })
      }
    }
  }
</script>
